import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// Components
import {ShowMessage,CustomInput,CustomButton,CustomTitle} from "../../components";
import { useSpin } from "../../components/SpinContext";
import { Col, Flex, Form, Row, message } from "antd";
import { GetEmailVerified, CreatePasswordApi } from "../../api's/auth";
// Assests
import CheckMarkIcon from "../../assets/images/check-mark.png";
import { devUseWarning } from "antd/es/_util/warning";


const CreatePassword = ({type}) => {
  const { showSpin, hideSpin } = useSpin();
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('token');
  const [isEmailSuccess, setIsEmailSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onFinish = (values) => {
    if (id && values.password) {
      let model = {
        new_password: values.password,
        confirm_password: values.password,
        token: id
      }
      showSpin();
      setIsFormValid(true);
      CreatePasswordApi(model).then((res) => {
        if (res?.data?.data?.is_success) {
          localStorage.clear();
          navigate("/login");
        }else{
          message.error(res?.dat?.data?.message);
        }
      })
        .catch((error) => {
          console.log(error)
        }).finally(() => {
          hideSpin();
          setIsFormValid(false);
        });


    }else{
      message.error("Something went wrong")
    }
  };



  useEffect(() => {
    if (id) {fetchData();  }
  
  }, []);




  const fetchData = async () => {
    try {
      showSpin();
      let xyz = id + '/';
      const res = await GetEmailVerified(xyz);
        if(res.data.data?.is_success){
          setIsEmailSuccess(true);
        }else{
          setIsEmailSuccess(false);
          setErrorMessage(res.data.detail)
        }
    } catch (err) {
      console.error(err);
    } finally {
      hideSpin();
    }
  };

  return (
    <>
      <div className="zl-create-pass">
        {isEmailSuccess ?
          <Flex vertical={true} align="center" justify="center" style={{ height: "inherit" }}>
            <ShowMessage heading="Email address verified" text={type==="reset"?"Reset password for your account to get started.":
              "Create a password for your account to get started."} icon={CheckMarkIcon}>
              <Flex justify="center">
                <Form form={form} name="validateOnly" onFinish={onFinish} layout="vertical" autoComplete="off">
                  <Row gutter={[16, 24]}>
                    <Col span={24}>
                      <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Please create your password' },
                        {
                          type: "string",
                          min: 6,
                          message: "Password must be at least 6 characters long.",
                        },
                        {
                          type: "string",
                          max: 20,
                          message: "Password cannot exceed 20 characters.",
                        },
                        ]}
                      >
                        <CustomInput
                          type="password"
                          placeholder="Enter password"
                          // width="260px"
                          height="36px"
                          border="0px"
                          bgColor="#F3F3F3"
                          textColor="#5E5E5E"
                          borderRadius="8px"
                          placeholderColor="#5E5E5E"
                        />
                      </Form.Item>
                    </Col>

                    <Col span={24}>
                      <Form.Item>
                        <CustomButton
                          text={type==="reset"?"Reset Password":"Create Password"}
                          block="block"
                          height="48px"
                          bgColor="#000"
                          color="#fff"
                          borderRadius="8px"
                          fontSize={16}
                          fontWeight={500}
                          htmlType="submit"
                          isFormValid={isFormValid}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Flex>
            </ShowMessage>

          </Flex> :
          <CustomTitle
            text={errorMessage}
            strong={true}
            color="#000000"
            fontSize="32px"
            lineHeight="3.782rem"
          />
        }

      </div>

      {/* <CustomButton text="Resend email" fontWeight="500" fontSize="16" lineHeight="20px" color="#000" height="48px" width="133px" borderRadius="8px" bgColor="#F3F3F3" /> */}
      {/* </Flex> */}
      {/* </div> */}
    </>
  );
};

export default CreatePassword;
